import { render, staticRenderFns } from "./RVBChargingpointsByObjectType.vue?vue&type=template&id=fb005a22"
import script from "./RVBChargingpointsByObjectType.vue?vue&type=script&lang=js"
export * from "./RVBChargingpointsByObjectType.vue?vue&type=script&lang=js"
import style0 from "./RVBChargingpointsByObjectType.vue?vue&type=style&index=0&id=fb005a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports